import React from 'react';
import { 
  BedIcon, 
  BedDoubleIcon, 
  UsersIcon
} from 'lucide-react';
import RoomCountSelect from './RoomCountSelect';
import TotalDisplay from './TotalDisplay';
import { useRepatCalculations } from './useRepatCalculations';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface RoomSectionProps {
  title: string;
  basePath: string;
  readOnly?: boolean;
  showDepartmentField?: boolean;
  showOthersField?: boolean;
}

const RoomSection = ({ 
  title, 
  basePath, 
  readOnly = false,
  showDepartmentField = false,
  showOthersField = false
}: RoomSectionProps) => {
  const {
    singles,
    doubles,
    triples,
    quadruples,
    quintuples,
    otherSpaces,
    additionalBeds,
    totalRooms,
    totalCapacity
  } = useRepatCalculations(basePath);

  return (
    <>
      <h2>{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {/* Room count selects */}
        <RoomCountSelect 
          icon={BedIcon} 
          label="Singles" 
          fieldName={`${basePath}.singles`} 
          defaultValue={singles} 
          readOnly={readOnly} 
        />
        
        <RoomCountSelect 
          icon={BedDoubleIcon} 
          label="Dobles" 
          fieldName={`${basePath}.doubles`} 
          defaultValue={doubles} 
          readOnly={readOnly} 
        />
        
        <RoomCountSelect 
          icon={UsersIcon} 
          label="Triples" 
          fieldName={`${basePath}.triples`} 
          defaultValue={triples} 
          readOnly={readOnly} 
        />
        
        <RoomCountSelect 
          icon={UsersIcon} 
          label="Cuádruples" 
          fieldName={`${basePath}.quadruples`} 
          defaultValue={quadruples} 
          readOnly={readOnly} 
        />
        
        <RoomCountSelect 
          icon={UsersIcon} 
          label="Quíntuples" 
          fieldName={`${basePath}.quintuples`} 
          defaultValue={quintuples} 
          readOnly={readOnly} 
        />

        {/* Department field (only for Habitaciones section) */}
        {showDepartmentField && (
          <div className="form-group">
            <Label className="form-label">Departamento</Label>
            <Input 
              type="text" 
              className={`form-input ${readOnly ? "bg-gray-100" : ""}`}
              disabled={readOnly}
            />
          </div>
        )}

        {/* Others field */}
        {showOthersField && (
          <div className="form-group">
            <Label className="form-label">Otros</Label>
            <Input 
              type="text" 
              className={`form-input ${readOnly ? "bg-gray-100" : ""}`}
              disabled={readOnly}
            />
          </div>
        )}
        
        <RoomCountSelect 
          icon={BedIcon} 
          label="Otras plazas" 
          fieldName={`${basePath}.otherSpaces`} 
          defaultValue={otherSpaces} 
          readOnly={readOnly} 
        />
        
        <RoomCountSelect 
          icon={BedIcon} 
          label="Camas adicionales" 
          fieldName={`${basePath}.additionalBeds`} 
          defaultValue={additionalBeds} 
          readOnly={readOnly} 
        />

        {/* Total displays */}
        <TotalDisplay 
          label="Total habitaciones" 
          fieldName={`${basePath}.totalRooms`} 
          value={totalRooms} 
        />
        
        <TotalDisplay 
          label="Total plazas" 
          fieldName={`${basePath}.totalCapacity`} 
          value={totalCapacity} 
        />
      </div>
    </>
  );
};

export default RoomSection;
